<template>
  <div>
    <breadcrumb :list='breadcrumbList'></breadcrumb>
    <el-card class='main'>
      <el-form ref='searchEmp' :model='searchEmp' class='searchEmp'>
        <el-row>

          <el-col :xs='24' :sm='12' :md='6' :lg='6'>
            <el-form-item label-width='75px'>
              <div slot='label'>是否合格</div>
              <el-select v-model='searchEmp.jchg' placeholder='请选择' style='width:100%'>
                <el-option v-for='item in sfList' :key='item.code' :label='item.title' :value='item.code'>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs='24' :sm='12' :md='{ span: 7, offset: 1 }' :lg='7'>
            <el-form-item label-width='75px'>
              <div slot='label'>检查日期</div>
              <el-date-picker v-model='searchEmp.time' type='datetimerange' style='width:100%' align='right'
                start-placeholder='开始日期' end-placeholder='结束日期' :default-time="['00:00:00', '23:59:59']"
                value-format='timestamp'>
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs='24' :sm='12' :md='12' :lg='7' style='float:right'>
            <el-row style='text-align:end;width:100%'>
              <el-button type='success' @click='add'> 新增</el-button>
              <el-button type='info' @click='clean_btn'>重置</el-button>
              <el-button type='primary' @click='search_btn'>查询</el-button>
            </el-row>
          </el-col>
        </el-row>
      </el-form>

      <Total :total='total'></Total>

      <!-- 表格 -->

      <el-table :data='list' style='width: 100%' :header-cell-style="{ background: '#F1F2F7', color: '#606266' }"
        @row-click='cellClick'>
        <el-table-column prop='rcjcdjxh' label='检查登记序列号' min-width='180' align='center'>
        </el-table-column>
        <el-table-column prop='jcjg' label='检查机构' min-width='180' align='center'>
        </el-table-column>
        <el-table-column prop='jcr_xm' label='检查人姓名' min-width='100' align='center'>
        </el-table-column>
        <el-table-column prop='jcrq' label='检查日期' align='center' min-width='160' :formatter='formatDate'>
        </el-table-column>
        <el-table-column prop='jchg' label='是否合格' align='center' min-width='90' :formatter='sfFliter'>
        </el-table-column>
        <el-table-column prop='csjc_jyqk' label='发现问题' min-width='90' align='center' show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop='create_time' label='创建时间' min-width='160' align='center'>
        </el-table-column>

      </el-table>

      <!-- 分页 -->

      <div class='page'>
        <el-pagination v-if='list.length != 0' class='fy' style='' layout='prev, pager, next' :total='total'
          :page-size='pageData.page_size' :current-page='pageData.page_no' @current-change='current_change' background>
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import Total from '@/components/total/index.vue'
import { getDaliyList } from '@/api/day_work.js'
import { formatDate } from '@/utils/index.js'
import { lists, filtersInfo } from '@/utils/dictionary.js'

export default {
  name: 'DailyInspectionIndex',
  data() {
    return {
      breadcrumbList: [
        { name: '公安机关日常检查', path: 'daily_inspect' }
      ],
      searchEmp: {},
      list: [],
      sfList: [],
      total: 0,
      pageData: {
        // count: null, //总数
        page_no: 1,  //现在
        page_size: 10 //每页条数
        // page:25 //总页数
      },
      loading: true
    }
  },
  created() {
    this.info()
  },
  methods: {
    async info() {
      const res = await getDaliyList({ ...this.pageData, ...this.searchInp })
      this.total = res.total_result
      this.pageData.page_no = res.page_no
      this.pageData.page_size = res.page_size
      this.list = res.items
      // 获取字典
      this.sfList = lists['SF']


    },
    add() {
      this.$router.push('/daily_inspect/add_daily_inspect')
    },
    clean_btn() { // 重置
      this.searchEmp = {}
      this.searchInp = {}
      this.info()
    },
    search_btn() { //查询
      // 当前页强制转为 1
      this.pageData.page_no = 1
      const time = this.searchEmp.time
      this.searchInp = {
        start_time: time ? time[0] / 1000 : '',
        end_time: time ? time[1] / 1000 : '',
        jchg: this.searchEmp.jchg
      }
      this.info()
    },
    cellClick({ id }) { //点击单元格,跳转详情
      this.$router.push({
        path: '/daily_inspect/daily_inspect_details',
        query: { id }
      })
    },
    current_change(val) { //分页功能
      this.pageData.page_no = val
      this.info()
    },
    formatDate(row, col, val) {
      if (!val && val != 0) return
      return formatDate(val)
    },
    sfFliter(row, col, val) {
      if (!val && val != 0) return
      return filtersInfo(this.sfList, val)
    }

  },
  beforeRouteLeave(to, from, next) {
    //离开页面如果去的详情  则缓存当前页面
    if (to.path === '/daily_inspect/daily_inspect_details') {
      this.$store.commit('setKeep', 'DailyInspectionIndex')
      next()
    } else {
      this.$store.commit('setKeep', '')
      next()
    }
    next()
  },
  components: { Total }
}
</script>

<style lang='less' scoped>
.revise {
  border-radius: 16px;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
}
</style>